import { type ReactNode, useEffect, useRef } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { InteractionStatus } from '@azure/msal-browser';
import { AuthLoading } from './AuthLoading';
import { loginRequest } from '@/auth/msalConfig';
import type { AuthGuardProps } from '@/types/auth.types';

export function AuthGuard({ children, loadingComponent }: AuthGuardProps): ReactNode {
  const { instance, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const redirectInitiated = useRef(false);

  useEffect(() => {
    if (inProgress === InteractionStatus.None && !isAuthenticated && !redirectInitiated.current) {
      redirectInitiated.current = true;

      const currentUrl = window.location.href;

      void instance.loginRedirect({
        ...loginRequest,
        state: currentUrl,
      });
    }
  }, [instance, inProgress, isAuthenticated]);

  if (inProgress !== InteractionStatus.None) {
    return loadingComponent ?? <AuthLoading />;
  }

  if (!isAuthenticated) {
    return loadingComponent ?? <AuthLoading />;
  }

  return <>{children}</>;
}
